import React from 'react'
import './index.scss'
import deleteIcon from '../../assets/images/ic_delete.png'

const SearchBar = props => {
    const { search, changeText, keywords, hint } = props
    const searchKeywords = () => {
        if(!keywords && hint) {
            changeText(hint)
        }
        search()
    }
    return (
        <div className="searchBarContent">
            <div className="searchInput">
                <img
                    className="searchIcon"
                    src="https://baleen-cdn-g.bybieyang.com/by/lego/2c609edd0c03d73f30e5d09d17acda79.png"
                ></img>
                <input
                    value={keywords || ''}
                    onChange={e => changeText(e.target.value)}
                    className="input"
                    placeholder={hint || "search"}
                ></input>
                {keywords && (
                    <img
                        src={deleteIcon}
                        className="deleteIcon"
                        onClick={e => changeText('')}
                    ></img>
                )}
            </div>
            <div className="searchText" onClick={searchKeywords}>
                搜索
            </div>
        </div>
    )
}

export default SearchBar
